// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"459":"ce20fe6b","691":"baa71da1","785":"221f2585"}[chunkId] + ".chunk.css";
};